
export class SubjectModel {
    constructor() { }
    public SubjectId: number;
    public Name: string;
    public IsNotSureSubject: boolean;
  }
